import Vue from 'vue'
import Modal from './modal.vue'
const defaultConfig = {}
const ModalConstructor = Vue.extend(Modal)
const instance = {
  create() {
    if (!instance.modal) {
      instance.modal = new ModalConstructor({
        el: document.createElement('div'),
      })
      document.body.appendChild(instance.modal.$el)
    }
  },
  show(config) {
    instance.create()
    const mergedConfig = Object.assign({}, defaultConfig, config)
    instance.modal.show = true
    instance.modal.config = mergedConfig
  },
  hide() {
    instance.modal && (instance.modal.show = false)
  },
}

export default instance
